class WebSalesTriggers {

  private clickTrigger:NodeListOf<HTMLElement>
  private visitTrigger:NodeListOf<HTMLElement>
  private leadTrigger:NodeListOf<HTMLElement>

  constructor() {
    this.clickTrigger = document.querySelectorAll('.js-websales-trigger-click');
    this.visitTrigger = document.querySelectorAll('.js-websales-trigger-visit');
    this.leadTrigger = document.querySelectorAll('.js-websales-trigger-lead');
  }

  /**
   * Init websales triggers
   */
  init(){
    if (this.clickTrigger.length > 0 || this.visitTrigger.length > 0 || this.leadTrigger.length > 0) {
      this.attachListeners()
    }
  }

  /**
   * Attach listeners to trigger elements
   */
  attachListeners() {
    this.clickTrigger.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        this.sendData({ triggerType: 'click', external_id: trigger.getAttribute('data-websales-external-id'), isNewCars: trigger.getAttribute('data-websales-isnewcars') })
      })
    })
    this.visitTrigger.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        this.sendData({ triggerType: 'visit', external_id: trigger.getAttribute('data-websales-external-id'), isNewCars: trigger.getAttribute('data-websales-isnewcars') })
      })
    })
    this.leadTrigger.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        this.sendData({ triggerType: 'lead', external_id: trigger.getAttribute('data-websales-external-id'), isNewCars: trigger.getAttribute('data-websales-isnewcars') })
      })
    })
  }

  /**
   * Send data to stage ajax function
   * @param params {Object} parameters of trigger
   */
  sendData(params = {}) {
    const queryString = new URLSearchParams({
      ...params,
      'stage-language': document.querySelector('html').getAttribute('lang'),
    }).toString()
    fetch(`/stage-ajax/saveVehicleStat/?${queryString}`).then(response => response.json()).then(data => {
    }).catch(e => {
      console.log(e);
    })
  }

}

export default new WebSalesTriggers();
